import { cn } from 'cn';
import { memo, type ReactNode } from 'react';

type P = {
  readonly Filters?: ReactNode;
  readonly SearchInput?: ReactNode;
  /**
   * Actions on the current row selection, shown only while something is
   * selected. They belong to the right-hand group rather than next to the
   * filters: that group is right-anchored, so an action appearing grows it
   * leftwards into empty space instead of pushing the search input across.
   */
  readonly BulkActions?: ReactNode;
  readonly CreateItemButton?: ReactNode;
  readonly DownloadButton?: ReactNode;
} & ComponentStyling;

export const FiltersRow = memo(
  ({
    BulkActions,
    className,
    CreateItemButton,
    DownloadButton,
    Filters,
    SearchInput,
    style,
  }: P) => (
    <div className={cn('flex items-center gap-4', className)} style={style}>
      {Filters ? (
        <div className="flex items-center gap-2">{Filters}</div>
      ) : null}
      {SearchInput ? <div className="w-80">{SearchInput}</div> : null}
      <div className="ml-auto flex items-center gap-2">
        {!!BulkActions && BulkActions}
        {!!CreateItemButton && CreateItemButton}
        {!!DownloadButton && DownloadButton}
      </div>
    </div>
  ),
);
